import { useEffect } from 'react';

import { ContentfulLivePreview } from '@contentful/live-preview';

import { consumePostLogoutRedirect, getCurrentPath } from '@/lib/logoutRedirect';

const useApp = () => {
  useEffect(() => {
    const redirectTo = consumePostLogoutRedirect();
    if (!redirectTo) return;

    if (redirectTo !== getCurrentPath()) {
      globalThis.location.replace(redirectTo);
    }
  }, []);

  useEffect(() => {
    // Initialize Contentful Live Preview
    ContentfulLivePreview.init({
      locale: 'en-US',
      debugMode: false,
      enableInspectorMode: true,
      enableLiveUpdates: true,
    });

    // Subscribe to the 'save' event to revalidate the content when saved
    const handleSave = async () => {
      const pathname = globalThis.location.pathname;
      await fetch(`/api/revalidate?pathname=${pathname}`);
      globalThis.location.reload(); // Refresh the page to see the new content
    };
    ContentfulLivePreview.subscribe('save', { callback: handleSave });
  }, []);

  const onRedirectCallback = (appState?: any | undefined, user?: any | undefined): void => {
    globalThis.location.href = appState?.returnTo ?? globalThis.location.pathname;
  };

  return {
    onRedirectCallback,
  };
};

export default useApp;
